// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html[data-v-178be4fe],\nbody[data-v-178be4fe],\n.v-application--wrap[data-v-178be4fe] {\n  background: #0a0f19 !important;\n}\n", ""]);
// Exports
module.exports = exports;
